import { render, staticRenderFns } from "./handleDialog.vue?vue&type=template&id=4b01acd6&scoped=true&"
import script from "./handleDialog.vue?vue&type=script&lang=js&"
export * from "./handleDialog.vue?vue&type=script&lang=js&"
import style0 from "./handleDialog.vue?vue&type=style&index=0&id=4b01acd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01acd6",
  null
  
)

export default component.exports